export const ERROR_MESSAGE_SELECT_ACTION = "Please select an action";
export const ERROR_MESSAGE_SELECT_ACTION_TYPE = "Please select an action type";
export const ERROR_MESSAGE_NAME_EMPTY = "Please select a name";
export const ERROR_MESSAGE_CREATE_APPLICATION =
  "We could not create the Application";
export const API_PATH_START_WITH_SLASH_ERROR = "Path cannot start with /";
export const FIELD_REQUIRED_ERROR = "This field is required";
export const VALID_FUNCTION_NAME_ERROR =
  "Must be a valid variable name (camelCase)";
export const UNIQUE_NAME_ERROR = "Name must be unique";
export const NAME_SPACE_ERROR = "Name must not have spaces";

export const FORM_VALIDATION_EMPTY_EMAIL = "Please enter an email";
export const FORM_VALIDATION_INVALID_EMAIL =
  "Please provide a valid email address";
export const ENTER_VIDEO_URL = "Please provide a valid url";

export const FORM_VALIDATION_EMPTY_PASSWORD = "Please enter the password";
export const FORM_VALIDATION_PASSWORD_RULE =
  "Please provide a password with a minimum of 6 characters";
export const FORM_VALIDATION_INVALID_PASSWORD = "Please enter a valid password";

export const LOGIN_PAGE_SUBTITLE = "Use your organization email";
export const LOGIN_PAGE_TITLE = "Login";
export const LOGIN_PAGE_EMAIL_INPUT_LABEL = "Email";
export const LOGIN_PAGE_PASSWORD_INPUT_LABEL = "Password";
export const LOGIN_PAGE_EMAIL_INPUT_PLACEHOLDER = "Email";
export const LOGIN_PAGE_PASSWORD_INPUT_PLACEHOLDER = "Password";
export const LOGIN_PAGE_INVALID_CREDS_ERROR =
  "It looks like you may have entered incorrect/invalid credentials. Please try again or reset password using the button below.";
export const LOGIN_PAGE_INVALID_CREDS_FORGOT_PASSWORD_LINK = "Reset Password";

export const LOGIN_PAGE_LOGIN_BUTTON_TEXT = "Login";
export const LOGIN_PAGE_FORGOT_PASSWORD_TEXT = "Forgot Password";
export const LOGIN_PAGE_REMEMBER_ME_LABEL = "Remember";
export const LOGIN_PAGE_SIGN_UP_LINK_TEXT = "New to UBOS? Sign up";
export const SIGNUP_PAGE_TITLE = "Sign Up";
export const SIGNUP_PAGE_SUBTITLE = "Use your organization email";
export const SIGNUP_PAGE_EMAIL_INPUT_LABEL = "Email";
export const SIGNUP_PAGE_EMAIL_INPUT_PLACEHOLDER = " Email";
export const SIGNUP_PAGE_NAME_INPUT_PLACEHOLDER = "Name";
export const SIGNUP_PAGE_NAME_INPUT_LABEL = "Name";
export const SIGNUP_PAGE_PASSWORD_INPUT_LABEL = "Password";
export const SIGNUP_PAGE_PASSWORD_INPUT_PLACEHOLDER = "Password";
export const SIGNUP_PAGE_LOGIN_LINK_TEXT = "Have an account? Login";
export const SIGNUP_PAGE_NAME_INPUT_SUBTEXT = "How should we call you?";
export const SIGNUP_PAGE_SUBMIT_BUTTON_TEXT = "Sign Up";

export const SIGNUP_PAGE_SUCCESS = "Awesome! You have successfully registered.";
export const SIGNUP_PAGE_SUCCESS_LOGIN_BUTTON_TEXT = "Login";

export const RESET_PASSWORD_PAGE_PASSWORD_INPUT_LABEL = "New Password";
export const RESET_PASSWORD_PAGE_PASSWORD_INPUT_PLACEHOLDER = "New Password";
export const RESET_PASSWORD_LOGIN_LINK_TEXT = "Changed your mind? Login";
export const RESET_PASSWORD_PAGE_TITLE = "Reset Password";
export const RESET_PASSWORD_SUBMIT_BUTTON_TEXT = "Reset";
export const RESET_PASSWORD_PAGE_SUBTITLE =
  "Create a new password for your account ";

export const RESET_PASSWORD_RESET_SUCCESS = "Your password has been reset"; //"Your password has been reset. Please login" (see next entry);
export const RESET_PASSWORD_RESET_SUCCESS_LOGIN_LINK = "Login";

export const RESET_PASSWORD_EXPIRED_TOKEN =
  "The password reset link has expired. Please try generating a new link";
export const RESET_PASSWORD_INVALID_TOKEN =
  "The password reset link is invalid. Please try generating a new link";
export const RESET_PASSWORD_FORGOT_PASSWORD_LINK = "Forgot Password";

export const FORGOT_PASSWORD_PAGE_EMAIL_INPUT_LABEL = "Email";
export const FORGOT_PASSWORD_PAGE_EMAIL_INPUT_PLACEHOLDER = "Email";
export const FORGOT_PASSWORD_PAGE_TITLE = "Reset Password";
export const FORGOT_PASSWORD_PAGE_SUBTITLE =
  "We will send a reset link to the email below";
export const FORGOT_PASSWORD_PAGE_SUBMIT_BUTTON_TEXT = "Reset";
export const FORGOT_PASSWORD_SUCCESS_TEXT =
  "A password reset link has been sent to";

export const PRIVACY_POLICY_LINK = "Privacy Policy";
export const TERMS_AND_CONDITIONS_LINK = "Terms and Conditions";

export const ERROR_500 =
  "We apologize, Something went wrong. We're working to fix things.";
export const ERROR_0 =
  "We could not connect to our servers. Please check your network connection";
export const ERROR_401 =
  "We are unable to verify your identity. Please login again.";
export const ERROR_403 =
  "Permission Denied. Please contact your admin to gain access.";
export const WIDGET_TYPE_VALIDATION_ERROR = "Value does not match type";
export const URL_HTTP_VALIDATION_ERROR = "Please enter a valid URL";
export const NAVIGATE_TO_VALIDATION_ERROR =
  "Please enter a valid URL or page name";

export const INVITE_USERS_VALIDATION_EMAIL_LIST =
  "Invalid Email address(es) found";
export const INVITE_USERS_VALIDATION_ROLE_EMPTY = "Please select a role";

export const INVITE_USERS_EMAIL_LIST_PLACEHOLDER = "Comma separated emails";
export const INVITE_USERS_ROLE_SELECT_PLACEHOLDER = "Select Role";
export const INVITE_USERS_ROLE_SELECT_LABEL = "Role";
export const INVITE_USERS_EMAIL_LIST_LABEL = "User emails";
export const INVITE_USERS_ADD_EMAIL_LIST_FIELD = "Add more";
export const INVITE_USERS_SUBMIT_BUTTON_TEXT = "Invite Users";
export const INVITE_USERS_SUBMIT_ERROR =
  "We were unable to invite the users, please try again later";
export const INVITE_USERS_SUBMIT_SUCCESS =
  "The users have been invited successfully";
export const INVITE_USERS_VALIDATION_EMAILS_EMPTY =
  "Please enter the user emails";

export const CREATE_PASSWORD_PAGE_PASSWORD_INPUT_LABEL = "New Password";
export const CREATE_PASSWORD_PAGE_PASSWORD_INPUT_PLACEHOLDER = "New Password";
export const CREATE_PASSWORD_LOGIN_LINK_TEXT =
  "Already know the password? Login";
export const CREATE_PASSWORD_PAGE_TITLE = "Set Password";
export const CREATE_PASSWORD_SUBMIT_BUTTON_TEXT = "Create";
export const CREATE_PASSWORD_PAGE_SUBTITLE =
  "Set a new password for your account ";

export const CREATE_PASSWORD_RESET_SUCCESS = "Your password has been set";
export const CREATE_PASSWORD_RESET_SUCCESS_LOGIN_LINK = "Login";

export const CREATE_PASSWORD_EXPIRED_TOKEN =
  "The invite link has expired. Please try requesting a new invite";
export const CREATE_PASSWORD_INVALID_TOKEN =
  "The invite link is invalid. Please try request a new invite";

export const DELETING_APPLICATION = "Deleting application...";
export const DUPLICATING_APPLICATION = "Duplicating application...";

export const CURL_IMPORT_SUCCESS = "Curl Import Successfull";
export const FORGOT_PASSWORD_PAGE_LOGIN_LINK = "Back to Login";
export const ADD_API_TO_PAGE_SUCCESS_MESSAGE = "Api added to page.";
export const INPUT_WIDGET_DEFAULT_VALIDATION_ERROR = "Invalid input";

export const AUTOFIT_ALL_COLUMNS = "Autofit all columns";
export const AUTOFIT_THIS_COLUMN = "Autofit this column";
export const AUTOFIT_COLUMN = "Autofit column";

export const TIMEZONE = "Timezone";
export const ENABLE_TIME = "Enable Time";

export const EDIT_APP = "Edit App";
export const FORK_APP = "Fork App";
export const SIGN_IN = "Sign In";

export const LIGHTNING_MENU_DATA_API = "Use data from an API";
export const LIGHTNING_MENU_DATA_QUERY = "Use data from a Query";
export const LIGHTNING_MENU_DATA_TOOLTIP = "Quick start data binding";
export const LIGHTNING_MENU_DATA_WIDGET = "Use data from a Widget";
export const LIGHTNING_MENU_QUERY_CREATE_NEW = "Create new Query";
export const LIGHTNING_MENU_API_CREATE_NEW = "Create new API";

export const LIGHTNING_MENU_OPTION_TEXT = "Plain Text";
export const LIGHTNING_MENU_OPTION_JS = "Write JS";
export const LIGHTNING_MENU_OPTION_HTML = "Write HTML";
export const CHECK_REQUEST_BODY = "Check Request body to debug?";
export const DONT_SHOW_THIS_AGAIN = "Don't show this again";
export const SHOW_REQUEST = "Show Request";

export const TABLE_FILTER_COLUMN_TYPE_CALLOUT =
  "Change column datatype to see filter operators";

export const WIDGET_SIDEBAR_TITLE = "Widgets";
export const WIDGET_SIDEBAR_CAPTION =
  "To add a widget, please drag and drop a widget on the canvas to the right";
export const GOOGLE_RECAPTCHA_KEY_ERROR =
  "Google Re-Captcha Token Generation failed! Please check the Re-captcha Site Key.";
export const GOOGLE_RECAPTCHA_DOMAIN_ERROR =
  "Google Re-Captcha Token Generation failed! Please check the allowed domains.";

export const SERVER_API_TIMEOUT_ERROR =
  "UBOS server is taking too long to respond. Please try again after some time";
